import { render, staticRenderFns } from "./snippets-history-page.vue?vue&type=template&id=584041e0&scoped=true&"
import script from "./snippets-history-page.vue?vue&type=script&lang=js&"
export * from "./snippets-history-page.vue?vue&type=script&lang=js&"
import style0 from "./snippets-history-page.vue?vue&type=style&index=0&id=584041e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584041e0",
  null
  
)

export default component.exports